/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-15 19:12:15
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnly,
} from '../../../models/datetime'
import { getUserList } from '../../user/userSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  getRecordOfAdverseReactionDetailAsync,
  getRecordOfAdverseReactionSubmitAsync,
} from './recordOfAdverseReactionsSlice'
import moment from 'moment'
import { selectUserId } from '../../../app/applicationSlice'

const { Option } = Select

export const AddOrEditModal = (props: {
  editTenantId?: any
  isEdit?: any
  id?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const userId = useSelector(selectUserId)

  const dispatch = useDispatch<RootDispatch>()

  const [userList, setUserList] = useState<any>()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [detail, setDetail] = useState<any>()

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 15 },
  }

  const getDetail = () => {
    dispatch(
      getRecordOfAdverseReactionDetailAsync({
        id: props?.id,
        tenantId: props?.editTenantId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
        form.setFieldsValue({
          ...v,
          reportUser: v?.reportUser?.toString(),
          birthDate: v?.birthDate ? moment(v?.birthDate) : '',
          reportDate: v?.reportDate ? moment(v?.reportDate) : '',
          sex: v?.sex?.toString(),
        })
      })
  }
  useEffect(() => {
    if (!props.isModalVisible) {
      form.resetFields()
    } else {
      if (props?.id) {
        getDetail()
      } else {
        form.setFieldsValue({
          sex: '1',
          reportUser: userId?.toString(),
        })
      }
    }
  }, [props.isModalVisible, props?.id])

  useEffect(() => {
    if (props.isModalVisible) {
      dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
        .then(unwrapResult)
        .then((res: any) => {
          setUserList(res?.items)
        })
    }
  }, [props.isModalVisible])

  return (
    <Modal
      width={1200}
      title={
        props?.isEdit == '0' ? '查看详情' : props?.id ? '编辑数据' : '添加数据'
      }
      visible={props.isModalVisible}
      footer={null}
      maskClosable={false}
      destroyOnClose={false}
      onCancel={() => {
        props.onCancel()
      }}
      onOk={() => {
        props?.onOk()
      }}
    >
      <Form
        autoComplete='off'
        form={form}
        onFinish={(vs) => {
          setConfirmLoading(true)
          const reportUserName = userList?.find(
            (v: any) => v?.id == vs?.reportUser
          )?.name
          const birthDate = vs?.birthDate
            ? moment(vs?.birthDate)?.format(DateTimeFormatSimpleOnly)
            : ''
          const reportDate = vs?.reportDate
            ? moment(vs?.reportDate)?.format(DateTimeFormatSimpleOnly)
            : ''
          const commonParam = {
            birthDate: birthDate,
            reportDate: reportDate,
          }
          const params = props?.id
            ? {
                ...detail,
                ...vs,
                id: detail?.id,
                ...commonParam,
                reportUserName: reportUserName || detail?.reportUserName,
              }
            : {
                ...vs,
                reportUserName: reportUserName,
              }
          dispatch(getRecordOfAdverseReactionSubmitAsync({ ...params }))
            .then(unwrapResult)
            .then((v: any) => {
              notification.success({
                message: '操作成功',
              })
            })
            .finally(() => {
              props?.onOk()
              setConfirmLoading(false)
            })
        }}
      >
        <Row>
          <Col span={8}>
            <Form.Item {...layout} label='病人姓名' name='patientName'>
              <Input placeholder='病人姓名' />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...layout} label='性别' name='sex'>
              <Select placeholder='性别' allowClear>
                <Option value='1'>男</Option>
                <Option value='2'>女</Option>
                <Option value='0'>未知</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...layout} label='出生日期' name='birthDate'>
              <DatePicker
                disabledDate={(date) => {
                  return moment(date).isAfter(moment().subtract(0, 'day'))
                }}
                style={{ width: '100%' }}
                placeholder='出生日期'
                format={DateTimeFormatSimple}
                onChange={() => {
                  return
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...layout} label='报告日期' name='reportDate'>
              <DatePicker
                style={{ width: '100%' }}
                placeholder='报告日期'
                format={DateTimeFormatSimple}
                onChange={() => {
                  return
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              {...layout}
              label='记录员'
              name='reportUser'
              rules={[
                {
                  required: true,
                  message: '记录员不能为空',
                },
              ]}
            >
              <Select placeholder='记录员' allowClear>
                {userList?.map((v: any, i: any) => {
                  return (
                    <Option value={v?.id} key={i}>
                      {v?.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...layout} label='备注' name='remark'>
              <Input placeholder='备注' />
            </Form.Item>
          </Col>
        </Row>
        {props?.isEdit == '0' ? (
          <></>
        ) : (
          <Row
            style={{
              marginTop: '20px',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              loading={confirmLoading}
              type='primary'
              onClick={() => {
                form.submit()
              }}
              style={{ marginRight: '10px' }}
            >
              确定
            </Button>
            <Button
              type='primary'
              ghost
              style={{ marginRight: '10px' }}
              onClick={() => {
                props?.onCancel()
              }}
            >
              取消
            </Button>
          </Row>
        )}
      </Form>
    </Modal>
  )
}
